// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__lDQxf"};